<template>
    <div class="load-more">
        <button v-if="mq" @click="loadMore" type="button" class="btn-default btn-default--1">
            Laad meer
        </button>
        <button v-else @click="loadMore" type="button" class="btn-default btn-default--3">
            Laad meer
        </button>
    </div>
</template>

<script setup lang="ts">
import { useMediaQuery } from '../../../composables/useMediaQuery';
import { useNewsOverviewStore } from '../store/news-overview.store';
import { ref, computed } from 'vue';
import { useFetch } from '../../../composables/useFetch';

const props = defineProps<{
    endpoint: string;
    isKnhs?: boolean;
}>();

const mq = useMediaQuery('(min-width: 1024px)');

const store = useNewsOverviewStore();

const endpointUrl = computed(() => {
    return props.isKnhs
        ? `${props.endpoint}?onlyKnhsEvents=${props.isKnhs}&`
        : `${props.endpoint}?`;
});

let count = ref(0);
const loadMore = async () => {
    if (count.value < store.totalPages) {
        count.value++;
        const { data } = await useFetch(`${endpointUrl.value}page=${count.value}`);
        if (data.value) {
            store.articles?.push(...data.value);
        }
    }
};
</script>
